import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { FieldService } from '../_services';
import * as FieldActions from '../_actions/field';

@Injectable({
  providedIn: 'root',
})
export class FieldEffects {
  loadFields$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActions.loadFields),
      // switchMap ensures only the latest request is active
      // if a new loadFields action comes in, the previous request is canceled
      switchMap(({ year }) =>
        this.fieldService.getFields(year).pipe(
          map((fields) => FieldActions.loadFieldsThinCrops({ fields })),
          catchError((error) => of(FieldActions.loadFieldsFailure({ error })))
        )
      )
    )
  );

  loadField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActions.loadField),
      mergeMap(({ id, year }) =>
        this.fieldService.getField(id, year).pipe(
          map((field) => FieldActions.loadFieldSuccess({ field })),
          catchError((error) => of(FieldActions.loadFieldFailure({ error })))
        )
      )
    )
  );

  addField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActions.addField),
      mergeMap(({ field }) =>
        this.fieldService.saveField(field).pipe(
          map((savedField) => FieldActions.addFieldSuccess({ field: savedField })),
          catchError((error) => of(FieldActions.addFieldFailure({ error })))
        )
      )
    )
  );

  updateField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActions.updateField),
      mergeMap(({ field }) =>
        this.fieldService.saveField(field).pipe(
          map((updatedField) => FieldActions.updateFieldSuccess({ field: updatedField })),
          catchError((error) => of(FieldActions.updateFieldFailure({ error })))
        )
      )
    )
  );

  deleteField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActions.deleteField),
      mergeMap(({ id }) =>
        this.fieldService.deleteField(id).pipe(
          map(() => FieldActions.deleteFieldSuccess({ id })),
          catchError((error) => of(FieldActions.deleteFieldFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private fieldService: FieldService
  ) {}
}
